// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueLazyLoad from 'vue-lazyload';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VideoPlayer from 'vue-video-player'; // 视频播放器
import 'video.js/dist/video-js.css'
import 'swiper/dist/css/swiper.css';
import training from "@/assets/js/training";
import reg from "@/assets/js/reg";
import filter from "@/assets/js/filter";
import err from "@/assets/js/errcode";
import store from './store/index';
import eventLog from './assets/js/eventLog.js'
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js';


//rem.js
require("@/assets/js/rem.js");
//CSS
import './assets/css/reset.css';
import './assets/font/iconfont.css';
import headers from "@/components/pages-header"; //引入头部组件
import DefaultGraph  from "@/components/common-default-images"; //引入缺省图组件
import scroll from "@/components/index-scroll.vue"; //引入滚动加载组件
import myTouch from './assets/js/myTouch.js';
myTouch(Vue)
Vue.use(eventLog)
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(ElementUI);
Vue.use(VideoPlayer);
Vue.use(VueAwesomeSwiper);
Vue.use(VueFullPage);
Vue.component("headers", headers);
Vue.component("default-scroll", scroll);
Vue.component("default-graph", DefaultGraph);
Vue.use(VueLazyLoad, {
  preLoad: 1,
  attempt: 1,
});
Vue.config.productionTip = false;
Vue.prototype.$zj = training;
Vue.prototype.$reg = reg;
Vue.prototype.$err = err;


var _hmt = _hmt || [];
window._hmt = _hmt; // 修改为window 全局变量
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?0954adcf9c3ee9ed6333e371b3daae68";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();


  router.beforeEach((to, from, next) => {
    if(from.path!="/login"){
      store.state.dialogPassworldIsShow=false;
    }

    if ((to.path == "/courseDetails" || to.path == "/fkxx")&&from.path=='/courseIndex') {
      console.log(11111)
      from.meta.keepAlive = true;
    }else if ((from.path == "/courseDetails" || from.path == "/fkxx")&&to.path=='/courseIndex') {
      console.log(2222)
      to.meta.keepAlive = true;
    } else if(from.path=='/homeIndex'||from.path=='/learnIndex'||from.path=='/personalIndex'){
      console.log(4444)
      if(to.path=='/courseIndex'){
        to.meta.keepAlive = false;
      }
    }
    if (window._hmt) {
      if (to.path) {
        window._hmt.push(['_trackPageview',to.fullPath])
      }
    }
    next()
  })






router.afterEach((to, from) => {
    let app = document.getElementById('app');
    app.addEventListener('DOMNodeRemoved', function(e) {
        var el = e.target
        let inputDom = document.getElementsByTagName('input');
        for (let i = 0; i < inputDom.length; i++) {
            inputDom[i].onblur = function () {
                setTimeout(() => {
                    window.scrollTo(0, document.body.scrollTop + 0);
                    document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 0);
                })
            }
        }
    });
    let commonDialog = document.getElementsByClassName("common-dialog")[0];
    if (commonDialog) {
        commonDialog.parentNode.removeChild(commonDialog);
    }
    training.loading(false);
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js